import React, { useState } from 'react';

import SiteApi from '../../Api/SiteApi/SiteApi';
import useOnce from '../../crm/hooks/useOnce';
import Loader from '../loader/Loader';

import UniversalDrawCounter from './UniversalDrawCounter';

type Props = { nextDraw?: string; nextNextDraw?: string; lottery?: string; isThankYouPage?: boolean };

export default function UniversalDrawCounterLoader({ nextDraw, nextNextDraw, lottery, isThankYouPage }: Props) {
    const [draws, setDraws] = useState<[string, string] | null>(null);
    const content = draws && (
        <UniversalDrawCounter nextDraw={draws[0]} nextNextDraw={draws[1]} isThankYouPage={isThankYouPage} />
    );

    useOnce(() => {
        if (nextDraw?.length) {
            setDraws([nextDraw, nextNextDraw]);
        } else if (lottery?.length) {
            SiteApi.get('lottery', { params: { display_slug: lottery } }).then((response) => {
                setDraws([response.data.nextDraw, response.data.nextNextDraw]);
            });
        }
    });

    return <Loader isLoading={!draws} elementToShow={content} />;
}
